import { GAME_TYPE, GameType } from 'constants/enums/GameTypeEnum'

export const styles = {
	card: {
		borderRadius: '0.6rem',
		border: 0,
		width: '100%',
	},
	cardContentReset: {
		'&:last-child': {
			paddingBottom: 0,
		},
		height: '100%',
		margin: 0,
		overflowY: 'visible',
		padding: 0,
		position: 'center',
	},
	circularProgressIcon: {
		color: 'secondary.main',
		size: '2.8rem',
	},
	container: (scrollable: boolean, gameTypeEnum?: GameType) => ({
		/*  Using viewport-based unit to fix flex overflow/stretch issue:
            vh ensures this container is always 30% of the viewport height.
            Unlike %, it doesn’t depend on parent height—so the vertical
            separator won’t grow past the visible scroll area. */
		maxHeight: '24vh',
		textAlign: 'center',
		alignItems: 'center',
		justifyContent: 'center',
		overflowX: scrollable ? 'hidden' : 'visible',
		overflowY: scrollable ? 'scroll' : 'visible',
		padding:
			gameTypeEnum === GAME_TYPE.LEAP_FROG ? '16px 32px' : '16px 24px',
	}),
	contentText: {
		textAlign: 'left',
		whiteSpace: 'pre-wrap',
	},
	battleShipTextStyle: {
		textAlign: 'left',
	},
	battleShipContainerStyles: {
		padding: '16px 32px 16px 32px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
}
